import { BaseHttpService, HttpRequest } from "@kernel/frontend-react-app";

export class StatsApiService extends BaseHttpService {
  constructor() {
    const fetch = HttpRequest.create("/api/stats");
    super(fetch);
  }

  public async save(content: unknown, name: string): Promise<void> {
    await this.post("/", { content, name });
  }
}
